import { useContext } from "react";
import { TimesheetFlowContext } from "@/features/timesheetFlow/timesheetFlowContextValue";

export function useTimesheetFlow() {
  const ctx = useContext(TimesheetFlowContext);
  if (!ctx) {
    throw new Error("useTimesheetFlow must be used within TimesheetFlowProvider");
  }
  return ctx;
}
